export default import.meta.ROLLDOWN_FILE_URL_bpVWdSEknexLGdRA4MyGkg